import {BaseDto} from '../../../../common/src/lib/dtos/base.dto';


export class FirebaseNotificationSendRequirementsDto extends BaseDto {
    language: string;

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }

    constructor(language: string) {
        super();
        this.language = language;
    }
}
